import React from "react"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"
import { reportFormDataInnit } from "Pages/ReportsAlerts/Reports/@signals"


export default function ReportTableCreateReportButton() {

	return <ButtonLoadingSeeker
		startIcon={<IconSeeker icon="file-plus"/>}
		onClick={() => reportFormDataInnit()}
	>
		Create Report
	</ButtonLoadingSeeker>
}